﻿import {useMemo} from "react";

export function useSelected(values: string[], multiple: boolean | undefined): (v: string) => boolean {
	return useMemo(() => multiple ? (v: string) => values.includes(v) : (v: string) => v === values[0], [values, multiple]);
}
